import { render, staticRenderFns } from "./WeeklySummary.vue?vue&type=template&id=15aab486&scoped=true&lang=pug"
import script from "./WeeklySummary.vue?vue&type=script&lang=js"
export * from "./WeeklySummary.vue?vue&type=script&lang=js"
import style0 from "./WeeklySummary.sass?vue&type=style&index=0&id=15aab486&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aab486",
  null
  
)

export default component.exports